export default function Icon({ name, size = 20, color = "currentColor", strokeWidth = 1.5 }) {
  const s = { width: size, height: size, display: "block", flexShrink: 0 };
  const p = { fill: "none", stroke: color, strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" };
  const icons = {
    rpt: (
      <svg viewBox="0 0 24 24" style={s}>
        <path {...p} d="M4 2h11l5 5v15a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1z"/>
        <path {...p} d="M14 2v6h6"/>
        <path {...p} d="M8 13h8M8 17h5"/>
      </svg>
    ),
    ttl: (
      <svg viewBox="0 0 24 24" style={s}>
        <rect {...p} x="3" y="3" width="14" height="18" rx="1"/>
        <path {...p} d="M7 8h7M7 12h7M7 16h4"/>
        <circle {...p} cx="19" cy="19" r="3"/>
        <path {...p} d="M21.1 21.1L23 23"/>
      </svg>
    ),
    spc: (
      <svg viewBox="0 0 24 24" style={s}>
        <path {...p} d="M3 10.5L12 3l9 7.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1v-9.5z"/>
        <path {...p} d="M12 21v-6"/>
        <path {...p} d="M9.5 13.5C9.5 12.12 10.5 11 12 12.5c1.5-1.5 2.5-.62 2.5.75 0 1-1 2-2.5 3.25C10.5 15.25 9.5 14.5 9.5 13.5z"/>
      </svg>
    ),
    apr: (
      <svg viewBox="0 0 24 24" style={s}>
        <circle {...p} cx="10" cy="10" r="7"/>
        <path {...p} d="M15.5 15.5L21 21"/>
        <path {...p} d="M7 10h6M10 7v6"/>
      </svg>
    ),
    bkg: (
      <svg viewBox="0 0 24 24" style={s}>
        <path {...p} d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 000-7.78z"/>
      </svg>
    ),
    mgt: (
      <svg viewBox="0 0 24 24" style={s}>
        <path {...p} d="M3 21h18"/>
        <path {...p} d="M5 21V7l7-4 7 4v14"/>
        <rect {...p} x="9" y="13" width="6" height="8"/>
        <path {...p} d="M9 10h6"/>
      </svg>
    ),
    env: (
      <svg viewBox="0 0 24 24" style={s}>
        <rect {...p} x="2" y="3" width="20" height="18" rx="1"/>
        <path {...p} d="M2 8h20M2 13h20M7 3v18M14 3v18"/>
        <circle {...p} cx="10.5" cy="10.5" r="1.5" fill={color} stroke="none"/>
      </svg>
    ),
    eia: (
      <svg viewBox="0 0 24 24" style={s}>
        <path {...p} d="M12 22V12"/>
        <path {...p} d="M12 12C12 12 7 10 5 6c4 0 7 2 7 6z"/>
        <path {...p} d="M12 16c0 0 5-2 7-6-4 0-7 2-7 6z"/>
        <path {...p} d="M5 22h14"/>
      </svg>
    ),
    pin: (
      <svg viewBox="0 0 24 24" style={s}>
        <path {...p} d="M12 2C8.69 2 6 4.69 6 8c0 4.5 6 12 6 12s6-7.5 6-12c0-3.31-2.69-6-6-6z"/>
        <circle {...p} cx="12" cy="8" r="2"/>
      </svg>
    ),
    mail: (
      <svg viewBox="0 0 24 24" style={s}>
        <rect {...p} x="2" y="4" width="20" height="16" rx="2"/>
        <path {...p} d="M2 4l10 9 10-9"/>
      </svg>
    ),
    phone: (
      <svg viewBox="0 0 24 24" style={s}>
        <rect {...p} x="5" y="2" width="14" height="20" rx="2"/>
        <path {...p} d="M10 17h4"/>
      </svg>
    ),
    clock: (
      <svg viewBox="0 0 24 24" style={s}>
        <circle {...p} cx="12" cy="12" r="9"/>
        <path {...p} d="M12 7v5l3 3"/>
      </svg>
    ),
  };
  return icons[name] || null;
}
